import { PenLine } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangSanXuat } from './pages/TrangSanXuat.js';

const production: KhaiBaoModule = {
  id: 'production',
  nav: {
    group: 'NỘI DUNG',
    label: 'Sản xuất',
    icon: PenLine,
    order: 1,
    permission: 'production',
    to: '/san-xuat',
  },
  routes: [
    {
      path: '/san-xuat',
      element: createElement(TrangSanXuat),
      permission: { module: 'production', level: 'view' },
    },
  ],
};

export default production;
